import React from 'react';
import PropTypes from 'prop-types';
import ShippingWeight from './ShippingWeight';
import MailingContainer from './MailingContainer';
import TrackingNumber from './TrackingNumber';
import CarrierService from './CarrierService';
import PackingSlip from './PackingSlip';

const ShippingColumn = (
  {
    shipment: {
      id,
      trackingNumber,
      shippingLabel,
      setWeight,
      calculatedWeight,
      mailingContainerName,
      mailingContainerId,
      shipBy,
      carrierServiceCode,
      requiresPackingSlip,
      orderSource,
    },
  },
) => (
  <span>
    { requiresPackingSlip && <PackingSlip id={id} /> }
    <ShippingWeight
      id={id}
      setWeight={setWeight}
      calculatedWeight={calculatedWeight}
    />
    <MailingContainer
      id={id}
      mailingContainerId={mailingContainerId}
      mailingContainerName={mailingContainerName}
    />
    <div><b className="mr-2">Ship By</b>{shipBy}</div>
    <CarrierService
      id={id}
      orderSource={orderSource}
      carrierServiceCode={carrierServiceCode}
    />
    <TrackingNumber
      id={id}
      trackingNumber={trackingNumber}
      shippingLabel={shippingLabel}
    />
  </span>
);

ShippingColumn.propTypes = {
  shipment: PropTypes.shape({
    id: PropTypes.number,
    trackingNumber: PropTypes.string,
    shippingLabel: PropTypes.object,
    setWeight: PropTypes.number,
    calculatedWeight: PropTypes.number,
    mailingContainerName: PropTypes.string,
    mailingContainerId: PropTypes.number,
    shipBy: PropTypes.string,
    carrierServiceCode: PropTypes.string,
    requiresPackingSlip: PropTypes.bool,
    orderSource: PropTypes.shape(),
  }).isRequired,
};

export default ShippingColumn;
